import styled from "styled-components";

export const AdminDashboardWrapper = styled("div")(() => {
  return {
    borderRadius: "1rem",
    backgroundColor: "var(--color-background)",
    padding: "var(--cardPadding)",
    "@media screen and (max-width: 425px)": {
      padding: "var(--cardPadding) 0",
    },
    "& .filter": {
      display: "flex",
      marginBlockEnd: "var(--sectionMargin)",
      gap: "2rem",
      "& select": {
        padding: "calc(var(--cardPadding)/4)",
        borderRadius: "0.45rem",
        border: "1px solid var(--color-primary-hover)",
        backgroundColor: "var(--color-button-secondary)",
        fontWeight: "400",
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 20,
        color: "var(--color-text)",
      },
      "& fieldset": {
        overflow: "hidden",
      },
    },
    "& .pie-chart-row": {
      justifyContent: "space-between",
      "& .pie-chart-container": {
        flex: 1,
        overflow: "hidden",
        minHeight: "200px",
      },
      "@media screen and (max-width: 425px)": {
        flexDirection: "column",
      },
    },
  };
});
